<template>
  <div class="dh-psy-top-menu__wrapper">
    <nav class="dh-psy-top-menu">
      <h2>
        <a href="https://www.nrk.no/selvmordipsykiatrien/">
          <span class="nrk-sr">Selvmord i psykiatrien</span>
          <div class="dh-psy-top-menu__logo" aria-hidden>
            <Logo type="large" />
          </div>
        </a>
      </h2>
    </nav>
  </div>
</template>

<script>
import Logo from './Logo.vue'

export default {
  components: { Logo }
}
</script>

<style scoped lang="postcss">
  :root {
    --dh-psy-top-logo-offset: 10%;
  }

  .dh-psy-top-menu__wrapper {
    margin: 0 auto;
    background: #fff;
    box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.11);
  }

  .dh-psy-top-menu {
    width: 100%;
    max-width: 1180px;
    margin: 0 auto;

    height: 46px;

    & h2 {
      margin: 0;
    }

    & a {
      position: relative;
      display: block;
      padding: 8px 18px 0;
      box-sizing: border-box;
      width: 270px;
      height: 46px;
    }

    & a:hover {
      background: rgba(0, 0, 0, 0.03);
    }
  }

  .dh-psy-top-menu__logo {
    position: absolute;
    left: 0;
    top: 0;
    display: inline-block;
    width: 100%;
    padding-top: 12px;
    & > * {
      margin-right: var(--dh-psy-top-logo-offset);
      width: 100%;
      height: 46px;
      min-width: auto;
      vertical-align: middle;
    }
  }
</style>
